import { ComponentChildren, h, Fragment } from 'preact'
import { PartiResultat } from '../../../domain'

type Props = {
  partier?: PartiResultat[]
  children: ComponentChildren
}

export function HasOppslutning(props: Props) {
  const { partier = [] } = props
  const hasOppslutning = partier.some(parti => parti.stemmer && parti.stemmer.prosent)

  if (hasOppslutning) {
    return <Fragment>{props.children}</Fragment>
  } else {
    return <Fragment />
  }
}
